import { call, put } from 'redux-saga/effects';
import { ACTIONS, APIS } from '../../_config';
import { CallApi } from '../api/callApi';




export function* GetAssetsList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_ASSETS_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetAssetNameByParam(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_ASSET_NAME_BY_PARAM, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetAssetCode(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_ASSET_CODE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetAssetCategory(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_ASSET_CATEGORY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            yield put({
                type: ACTIONS.MASTER.ASSETS_CATEGORIES, payload: resp.data.assetCategoryList.map((facilist: any) => {
                    return {
                        label: facilist.categoryName,
                        value: facilist.categoryID,
                    };
                })
            });
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetAssetDepartment(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_ASSET_DEPARTMENT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            
            yield put({
                type: ACTIONS.MASTER.ASSETS_DEPARTMENTS, payload: resp.data.departmentsList.map((facilist: any) => {
                    return {
						label: facilist.departmentName,
						value: facilist.departmentID,
					};
                })
            });
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetAssetGroupList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_ASSET_GROUPLIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            yield put({
                type: ACTIONS.MASTER.ASSETS_GROUPS, payload: resp.data.assetGroupList.map((facilist: any) => {
                    return {
						label: facilist.assetGroupName,
						value: facilist.assetGroupID,
					};
                })
            });
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

/* export function* GetAssetSubGroupList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_ASSET_SUBGROUPLIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            yield put({
                type: ACTIONS.MASTER.ASSETS_SUB_GROUPS, payload: resp.data.assetSubGroupList.map((facilist: any) => {
                    return {
						label: facilist.assetSubGroupName,
						value: facilist.assetSubGroupID,
					};
                })
            });
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
} */
export function* GetAssetSubGroupList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_ASSET_SUBGROUPLIST, data, true);

        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            const list = Array.isArray(resp.data.assetSubGroupList) ? resp.data.assetSubGroupList : [];

            yield put({
                type: ACTIONS.MASTER.ASSETS_SUB_GROUPS,
                payload: list.map((facilist: any) => ({
                    label: facilist.assetSubGroupName,
                    value: facilist.assetSubGroupID,
                })),
            });

            action?.callbackSuccess?.(resp.data);
        } else {
            action?.callbackError?.(resp?.data?.message || "Unknown error");
        }
    } catch (e: any) {
        action?.callbackError?.(e?.data ?? e);
    }
}


export function* GetAssetTypeList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_ASSET_TYPE_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            yield put({
                type: ACTIONS.MASTER.ASSETS_TYPES, payload: resp.data.assetTypeList.map((facilist: any) => {
                    return {
						label: facilist.assetTypeName,
						value: facilist.assetTypeID,
					};
                })
            });
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetAssetClassificationList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_ASSET_CLASIFICATION_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            yield put({
                type: ACTIONS.MASTER.ASSETS_CLASSIFICATIONS, payload: resp.data.assetClassificationList.map((facilist: any) => {
                    return {
						label: facilist.assetClassificationName,
						value: facilist.assetClassificationID,
					};
                })
            });
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetAssetStatusList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_ASSET_STATUS_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            yield put({
                type: ACTIONS.MASTER.ASSETS_STATUES, payload: resp.data.assetStatusList.filter((o:any) => o.isVisible).map((facilist: any) => {
                    return {
						label: facilist.statusName,
						value: facilist.statusID,
					};
                })
            });
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetvenderList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_VENDOR_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* saveAssets(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.ASSETS.SAVE_ASSETS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* deleteAsset(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.ASSETS.DELETE_ASSETS+"?assetID="+data.assetID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* updateStatus(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.PUT, APIS.ASSETS.UPDATE_STATUS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}




export function* GetnoteList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.NOTE_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* saveNotes(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.ASSETS.NOTE_SAVE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* deleteNotes(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.ASSETS.DELETE_NOTES+"?assetID="+data.assetID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetAttachmentList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_ASSET_ATTACHMENT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* SaveAssetAttachment(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.ASSETS.SAVE_ASSET_ATTACHMENT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* SaveAssetImage(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.ASSETS.SAVE_ASSET_IMAGE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* DeleteAssetAttachment(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.ASSETS.DELETE_ASSET_ATTACHMENT+"?AssetAttachmentID="+data.AssetAttachmentID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}



export function* Exportcsv(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.EXPORT_TO_CSV, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* Exportpdf(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.EXPORT_TO_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* ExportQrCode(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.ASSETS.EXPORT_QR_CODE, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportQrCodePng(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.ASSETS.EXPORT_QR_CODE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetWarrantyList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_WARRANTY_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* SaveAssetWarrantyAttachment(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.ASSETS.SAVE_ASSET_WARRANTY_ATTACHMENT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* WarrantyExportToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.WARRANTY_EXPORT_TO_XLS, data, true,true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetAssetWarrantyAttachments(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_WARRANTY_ATTACHMENTS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* SaveAssetWarranty(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.ASSETS.SAVE_ASSET_WARRANTY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* SaveAssetDetails(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.ASSETS.SAVE_ASSET_DETAILS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWarrantyTermList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_WARRANTY_TERM_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetJournalEntryByAssetId(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_JOURNAL_ENTRY_BY_ASSET_ID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}



export function* MoveAsset(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.ASSETS.MOVE_ASSET, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetAssetDetailsList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_ASSET_DETAILS_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetAssetStatusLog(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_ASSET_STATUS_LOG, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* DeleteAssetDetails(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.ASSETS.DELETE_ASSET_DETAILS+"?assetDetailsID="+data?.assetDetailsID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetAssetMovementLogList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_ASSET_MOVEMENT_LOG_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportAssetReportCsv(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.EXPORT_ASSET_REPORT_CSV, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetAssetsReportList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_ASSETS_REPORT_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ConvertToOwnedAsset(action: any): any {
    try {
        console.log("ConvertToOwnedAsset saga called with payload:", action.payload);
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.ASSETS.CONVERT_TO_OWNED_ASSET, data, true);
        console.log("ConvertToOwnedAsset API response:", resp);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            console.log("ConvertToOwnedAsset API error response:", resp.data);
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        console.log("ConvertToOwnedAsset saga exception:", e);
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWorkOrderUsedSpareParts(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.ASSETS.GET_WORKORDER_USED_SPARE_PARTS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetMtbfReport(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_MTBF_REPORT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetMttrReport(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_MTTR_REPORT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetMttrReportFilters(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_MTTR_REPORT_FILTERS, {}, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetSparePartsUsageReport(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.ASSETS.GET_SPARE_PARTS_USAGE_REPORT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportMttrReportToXLS(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.ASSETS.EXPORT_MTTR_REPORT_XLS, action.payload, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportMtbfReportToXLS(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.ASSETS.EXPORT_MTBF_REPORT_XLS, action.payload, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportSparePartsUsageReportToXLS(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.ASSETS.EXPORT_SPARE_PARTS_USAGE_REPORT_XLS, action.payload, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}